import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero3 from "../components/Hero3";
import EstoreComponent from "../components/EstoreComponent";
import Footer from "../components/Footer";

const EstorePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="estore-page">
      <Navbar />
      <Hero3 />
      <EstoreComponent />
      <Footer />
    </div>
  );
};

export default EstorePage;
